import clsx from 'clsx';
import React from 'react';

type CheckboxWithLabelProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
};

export const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({ checked, onChange, label, description }) => {
  const isChecked = checked ? 'bg-[#113D7B] outline-1 outline-[#113D7B]' : 'bg-transparent outline-1 outline-[#767676]';

  return (
    <div
      className="self-stretch p-2 bg-white rounded-lg outline-1 outline-[#E5E7EB] -outline-offset-1 flex items-center gap-2 cursor-pointer"
      onClick={() => onChange(!checked)}
    >
      {/* Circular checkbox */}
      <div className="w-5 h-5 relative overflow-hidden">
        <div
          className={clsx(
            'w-[12.5px] h-[12.5px] left-[3.75px] top-[3.75px] absolute rounded-full -outline-offset-[0.5px]',
            isChecked
          )}
        />
      </div>
      {/* Label and description */}
      <div className="flex-1 flex flex-col items-start gap-0.5">
        <div className="flex items-center gap-1">
          <div className="text-black text-sm font-medium break-words">{label}</div>
        </div>
        {description && (
          <div className="self-stretch text-[#767676] text-xs font-normal leading-[1.67] break-words">
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
